export const uiDe = {
  nav: {
    exploring: "Aktuell",
    about: "Über mich",
    education: "Ausbildung",
    experience: "Erfahrung",
    research: "Forschung",
    gallery: "Galerie",
    journal: "Journal",
    contact: "Kontakt",
    cv: "CV",
  },
  hero: {
    portfolio: "Portfolio",
    greeting: "Hi, ich bin",
    note: "das bin ich! →",
    begin: "Meine Geschichte entdecken",
    downloadCv: "CV herunterladen",
    scroll: "Scrollen & entdecken",
    fig: "Abb. 01 — Die Menschenbeobachterin",
    est: "Hyderabad → Dortmund",
  },
  exploring: {
    chapter: "Aktuell in Arbeit",
    titleA: "Eine lebendige Seite,",
    titleB: "immer im Werden",
    stamp: "Zuletzt aktualisiert · Juli 2026",
  },
  about: {
    chapter: "Über mich",
    titleA: "Eine Psychologin",
    titleB: "in Ausbildung",
    titleC: "eine Geschichtenerzählerin aus Leidenschaft",
    note: "ein bisschen über mich",
    photoCaption: "Café-Gedanken, vermutlich über Menschen",
  },
  education: {
    chapter: "Ausbildung",
    titleA: "Eine Ausbildung in",
    titleB: "zwei Welten",
    titleC: "— Geist und Markt",
  },
  experience: {
    chapter: "Erfahrung",
    titleA: "Keine Pflichtenliste —",
    titleB: "eine Geschichte des Wachsens",
    learned: "Was ich gelernt habe",
    impact: "Wirkung",
  },
  research: {
    chapter: "Forschung & Projekte",
    titleA: "Das Herzstück —",
    titleB: "Fragen, die mich treiben",
    intro: "Akademische Projekte, klinische Fallarbeit und laufende Forschung. Wählen Sie ein Kapitel, um die ganze Studie zu lesen.",
    objective: "Ziel",
    methodology: "Methodik",
    outcome: "Ergebnis",
    keyLesson: "Zentrale Erkenntnis",
  },
  skills: {
    chapter: "Fähigkeiten & Expertise",
    titleA: "Ein Werkzeugkasten",
    titleB: "aus vielen Disziplinen",
  },
  certificates: {
    chapter: "Zertifikate & Auszeichnungen",
    titleA: "Neugier —",
    titleB: "formell anerkannt",
    titleC: "",
    achievements: "Auszeichnungen",
  },
  interests: {
    chapter: "Jenseits der Universität",
    titleA: "Der Mensch hinter",
    titleB: "den Zeugnissen",
    note: "außerhalb der Uni-Bubble",
    open: "Seite öffnen",
    intro: "Lesen, Fotografie, Reisen, Journaling, Kaffee, Design — die Gewohnheiten, die die Forscherin menschlich halten.",
  },
  beyond: {
    back: "Zurück zum Portfolio",
    fromJournal: "Aus dem Journal — Essays findest du hier",
    emptyTitle: "Noch nichts hier",
    emptyText: "Diese Seite ist frisch — Einträge kommen bald.",
    categories: {
      reading: { name: "Lesen", tagline: "Bücher, die Menschen erklären" },
      photography: { name: "Fotografie", tagline: "die preisgekrönte Gewohnheit des Beobachtens" },
      traveling: { name: "Reisen", tagline: "Kulturen als Feldstudien" },
      journaling: { name: "Journaling", tagline: "wo Gedanken zu Fragen werden" },
      "coffee-culture": { name: "Kaffeekultur", tagline: "jede Stadt, erinnert in Cafés" },
      growth: { name: "Persönliches Wachstum", tagline: "eine lebenslange Pilotstudie" },
    },
  },
  gallery: {
    chapter: "Galerie",
    titleA: "Ein editoriales",
    titleB: "Fototagebuch",
    note: "kleine Momente, die ich behalten habe",
    intro: "Reisen, Konferenzen, Unileben und der Alltag — ausgewählte Bilder aus den Feldnotizen einer Fotografin aus Leidenschaft.",
  },
  resume: {
    chapter: "Lebenslauf",
    titleA: "Die",
    titleB: "Eine-Seiten",
    titleC: "Version",
    intro: "Ein kompakter, druckfertiger Überblick über Ausbildung, klinische Erfahrung und Fähigkeiten — für Recruiter, Professoren und Neugierige.",
    download: "Lebenslauf als PDF",
    note: "die formelle Version, versprochen",
    profile: "Profil",
    education: "Ausbildung",
    experience: "Erfahrung",
    coreSkills: "Kernkompetenzen",
    profileText:
      "Engagierte Psychologie-Studentin mit umfangreicher klinischer Praktikumserfahrung in pädiatrischen, kognitiven und beratenden Settings. Versiert in psychometrischer Diagnostik, evidenzbasierten Interventionen und funktionsübergreifender Zusammenarbeit — mit dem Anspruch empathischer, datengetriebener Ergebnisse.",
  },
  contact: {
    chapter: "Kontakt",
    titleA: "Lassen Sie uns",
    titleB: "ins Gespräch kommen",
    intro:
      "Ob Forschungskooperation, Praktikum, eine Frage zur Arbeits- und Organisationspsychologie oder einfach eine Buchempfehlung — mein Posteingang ist immer offen.",
    writeToMe: "Schreiben Sie mir",
    nameLabel: "Ihr Name",
    emailLabel: "Ihre E-Mail",
    messageLabel: "Nachricht",
    namePh: "Max Mustermann",
    emailPh: "max@beispiel.de",
    messagePh: "Hallo Sahithi, ich habe Ihr Portfolio gesehen und…",
    send: "Nachricht senden",
    sending: "Wird gesendet…",
    toastSuccess: "Nachricht gesendet — vielen Dank! Ich melde mich bald.",
    toastError: "Etwas ist schiefgelaufen — schreiben Sie mir bitte direkt per E-Mail.",
    emailSmall: "E-Mail",
    phoneLabel: "Telefon",
    connect: "Vernetzen wir uns",
    basedIn: "Standort",
  },
  footer: {
    tagline: "Psychologie & Management — Dortmund · Hyderabad · New York",
    backToTop: "Nach oben",
    copyright: "© 2026 Sahithi Rasakonda. Mit Neugier geschrieben, gestaltet und fotografiert.",
    quote: "„Evidenz und Empathie gehören zusammen.“",
  },
  journal: {
    back: "Zurück zum Portfolio",
    kicker: "Das Journal",
    sub: "Gelegentliche Essays",
    titleA: "Notizen über Menschen,",
    titleB: "Arbeit und Staunen",
    intro: "Psychologie, Führung, Forschung, Bücher und Reisen — Gedanken aus einer akademischen Reise, die noch geschrieben wird.",
    readEssay: "Essay lesen",
    read: "Lesen",
    allEssays: "Alle Essays",
    notFound: "Dieser Essay scheint sich verlaufen zu haben.",
  },
};
